"use strict";

var contractsWidget = function () {
  var contractsWidgetParams = {
    added: 0,
    // amount of newly added contracts
    modalTitle: 'Подтверждение принадлежности договора'
  };
  var timerOn = false;
  var _int = null;
  var $saveBtn = null;
  var $loader = null;

  function collectContractsData() {
    var contracts = [];
    var $contractsList = $('.person-contract-list').find('.user-list-row.-edited');
    $contractsList.each(function () {
      var $contractRow = $(this);
      var contract = {
        EntityType: $contractRow.find('.person-contract-entity').val(),
        BuldingObject: $contractRow.find('.person-contract-obj :selected').text(),
        BuldingObjectId: $contractRow.find('.person-contract-obj').val(),
        ObjectNumber: $contractRow.find('.person-contract-number').val().trim()
      };
      contracts.push(contract);
    });
    return contracts;
  }

  function updateContractsTbl() {
    var $personContracts = $('.person-contract-list');
    var $newContracts = $personContracts.find('.user-list-row.-edited');
    $personContracts.removeClass('-edit-mode');
    $newContracts.find('.user-list-cell').removeClass('-left-border -padded');
    $newContracts.find('.user-list-cell:not(.-extra)').addClass('-disabled');
    $newContracts.find('.person-contract-number').attr('disabled', 'disabled');
    $newContracts.find('.select').attr('disabled', 'disabled').selectric('refresh');
    $newContracts.find('.person-contract-action').remove();
    $newContracts.removeClass('-edited');
  }

  function showSuccessModal() {
    modalDialog.showBaseWnd({
      title: 'Информация',
      buttons: [{
        title: 'Хорошо',
        big: true,
        primary: true
      }],
      onDrawContent: function onDrawContent() {
        return 'Данные успешно сохранены';
      }
    });
  }

  function checkBindings(dataSet) {
    $loader.show();
    $.ajax({
      type: 'POST',
      url: contractsWidgetParams.url.checkBindingsUrl,
      data: {
        model: dataSet
      },
      success: function success(xhr) {
        if (xhr.Success) {
          if (xhr.Result === 'CustomerAccountOnly') {
            timerOn = false;
            showSuccessModal();
          }

          if (Array.isArray(xhr.Result) && xhr.Result.length === 1) {
            // показываем модалку с одним носером телефона
            $('text[name=phone-number]').text(xhr.Result[0]);
            $('#one-phone-number-modal').showAsModal({
              title: contractsWidgetParams.modalTitle
            });
          }

          if (Array.isArray(xhr.Result) && xhr.Result.length > 1) {
            // показываем модалку с несколькими номерами
            var modal = renderHtml('multiple-phone-number-modal', {
              phoneNumbers: xhr.Result
            });
            $(modal).showAsModal({
              title: contractsWidgetParams.modalTitle
            });
          }

          updateContractsTbl();
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return xhr.Result;
            }
          });
        }

        $loader.hide();
      }
    });
  }

  function saveBindings(confirmCode) {
    $.ajax({
      type: 'POST',
      url: contractsWidgetParams.url.saveBindings,
      data: {
        confirmationCode: confirmCode
      },
      success: function success(xhr) {
        if (xhr.Success) {
          $('#approve-code-modal').closest('.modal').modalDlgClose();
          timerOn = false;
          showSuccessModal();
        } else {
          switch (xhr.Result.ErrorType) {
            case 'validationEx':
              $('#validate-error').text(xhr.Result.ErrorMessage);
              break;

            case 'serverEx':
              $('#approve-code-modal').closest('.modal').modalDlgClose();
              timerOn = false;
              modalDialog.showBaseWnd({
                title: 'Ошибка',
                buttons: [{
                  title: 'Хорошо',
                  big: true,
                  primary: true
                }],
                onDrawContent: function onDrawContent() {
                  return xhr.Result.ErrorMessage;
                }
              });
              break;

            default:
              console.error('Unhandled savebindings error');
              break;
          }
        }
      }
    });
  }

  function modalMinuteCountdown() {
    timerOn = true;
    var seconds = 60;
    $(".modal-footer.-space-between").show();
    $('#confirm-time').html(seconds);

    var setParam = function setParam() {
      $('#confirm-param').hide();
      $(".modal-footer.-space-between").hide();
      $('#resend-confirm-param').show();
      $('#validate-error').text('');
      $('#confirmation-code').val('');
      $('#confirm-time').html('');
    };

    _int = setInterval(function () {
      $('#confirm-time').html(seconds - 1);
      seconds -= 1;

      if (!timerOn || seconds <= 0) {
        setParam();
        clearInterval(_int);
      }
    }, 1000);
  }

  function getConfirmationCode(modalSelector) {
    $.ajax({
      type: 'POST',
      url: contractsWidgetParams.url.sendCodeOnPhone,
      data: {
        phoneNumber: contractsWidgetParams.phoneNumber
      },
      success: function success(xhr) {
        if (xhr.Success) {
          $('#confirm-param').show();
          $('#resend-confirm-param').hide();
          timerOn = false;

          if (modalSelector) {
            $(modalSelector).closest('.modal').modalDlgClose();
            $('#approve-code-modal').showAsModal({
              title: contractsWidgetParams.modalTitle,
              inputs: [{
                id: 'confirmation-code',
                placeholder: 'Полученный код'
              }],
              buttons: [{
                title: 'Подтвердить',
                big: true,
                primary: true,
                onClick: function onClick() {
                  var confirmCode = $('#confirmation-code').val();

                  if (!confirmCode) {
                    $('#validate-error').text('Введите код подтверждения');
                  } else {
                    saveBindings(confirmCode);
                  }

                  return false;
                }
              }]
            });
          }

          modalMinuteCountdown();
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return xhr.Result;
            }
          });
        }
      }
    });
  }

  function bindHandlers() {
    $saveBtn.attr('disabled', true);
    $(document).on('click', '#saveBindingBtn', function () {
      var isValid = true;
      var dataSet = {
        ExistingContractsList: contractsWidgetParams.model.bindingList,
        ContractBindingList: collectContractsData()
      };
      var passedValidation = validation.validateContracts(dataSet);
      isValid = isValid && passedValidation;

      if (isValid) {
        $('#saveBindingsModal').showAsModal({
          title: 'Внимание',
          buttons: [{
            title: 'Да',
            big: true,
            primary: true,
            onClick: function onClick() {
              checkBindings({
                SelectedContracts: dataSet.ContractBindingList.filter(function (item) {
                  return item.EntityType === 'clientContract';
                }),
                SelectedCustomerAccounts: dataSet.ContractBindingList.filter(function (item) {
                  return item.EntityType === 'customerAccount';
                })
              });
            }
          }, {
            title: 'Нет',
            big: true
          }]
        });
      }
    });
    $(document).on('click', '#addBindingBtn', function () {
      var $contractsList = $('.person-contract-list');
      var contractItem = $('#building-object-row').html();
      contractsWidgetParams.added += 1;
      $saveBtn.attr('disabled', false);
      $contractsList.addClass('-edit-mode');
      $contractsList.find('.user-list-body').append(contractItem);

      if (window.innerWidth < 680) {
        LKCommon.initSelectric($contractsList.last('.user-list-row').find('.select'));
        $('.person-contract-list .selectric-items').addClass('selectrickWidthForMobileWidth');
      } else {
        $('.person-contract-list .selectric-items').removeClass('selectrickWidthForMobileWidth');
        LKCommon.initExpandedSelectric($contractsList.last('.user-list-row').find('.select'));
      }
    });
    $(document).on('click', '.person-contract-remove', function () {
      var $this = $(this);
      var $contractsList = $('.person-contract-list');
      contractsWidgetParams.added -= 1;
      $this.closest('.user-list-row').remove();

      if (contractsWidgetParams.added === 0) {
        $saveBtn.attr('disabled', true);
        $contractsList.removeClass('-edit-mode');
      }

      if ($('.user-list-row').length <= 3) {
        $("#addBindingBtn").show();
      }
    });
    $(document).on('click', '#one-phone-send, #multiple-phone-send, #resend-link', function () {
      switch ($(this).attr('id')) {
        case 'one-phone-send':
          contractsWidgetParams.phoneNumber = $('[name=phone-number]').text();
          getConfirmationCode('#one-phone-modal-content');
          break;

        case 'multiple-phone-send':
          contractsWidgetParams.phoneNumber = $('.modal-dialog #select-phone-number option:selected').text();
          getConfirmationCode('#multiple-phone-modal-content');
          break;

        case 'resend-link':
          getConfirmationCode(null);
          break;

        default:
          console.error('Such button is not defined');
          break;
      }
    });
    $(document).on('change focus', '.inp, .radio, .checkbox, .selectric-select', function () {
      var $this = $(this);
      var $field = $this.closest('.field');
      validation.setFieldValid($field);
    });
  }

  function cacheNodes() {
    $saveBtn = $('#saveBindingBtn');
    $loader = $('.loader.-local');
  }

  function unbindHandlers() {
    $(document).off('click', '#saveBindingBtn');
    $(document).off('click', '#addBindingBtn');
    $(document).off('click', '.person-contract-remove');
    $(document).off('click', '#one-phone-send, #multiple-phone-send, #resend-link');
    $(document).off('change focus', '.inp, .radio, .checkbox, .selectric-select');
  }

  function setParams(contractsParams) {
    contractsWidgetParams = $.extend({}, contractsWidgetParams, contractsParams);
  }

  function InitGrid() {
    if ($(".user-list-body").children().length == 0) {
      $("#addBindingBtn").click();
    }
  }

  function RemoveAddBindingBtn() {}

  function init(contractsParams) {
    unbindHandlers();
    cacheNodes();
    setParams(contractsParams);
    bindHandlers();
    InitGrid();
  }

  return {
    init: init
  };
}();